const API_BASE = process.env.REACT_APP_API_BASE || '/api';

export async function login(login, senha) {
  const res = await fetch(`${API_BASE}/users/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ login: login.toLowerCase(), senha })
  });

  const body = await res.json().catch(() => null);

  if (!res.ok) {
    const msg = body?.message || body?.error || res.statusText || 'Login inválido';
    throw new Error(msg);
  }

  return body.token;
}

// VAGAS -----------------------------------------------------------------------------------

export async function fetchVagas() {
  const resp = await fetch(`${API_BASE}/vagas`);
  const body = await resp.json().catch(() => null);

  if (!resp.ok) {
    const msg = body?.message || body?.error || resp.statusText || 'Bad response fetchVagas';
    throw new Error(msg);
  }

  return await body;
}

export async function fetchActiveVagas() {
  const resp = await fetch(`${API_BASE}/vagas/activevagas`);
  const body = await resp.json().catch(() => null);

  if (!resp.ok) {
    const msg = body?.message || body?.error || resp.statusText || 'Bad response fetchActiveVagas';
    throw new Error(msg);
  }

  return await body;
}

export async function fetchVaga(code) {
  const res = await fetch(`${API_BASE}/vagas/${code}`);
  const body = await res.json().catch(() => null);

  if (!res.ok) {
    const msg = body?.message || body?.error || res.statusText || 'Bad response fetchVaga';
    throw new Error(msg);
  }

  return await body;
}

export async function createVaga(vaga) {
  const token = localStorage.getItem("token");

  const res = await fetch(`${API_BASE}/vagas`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
    credentials: 'include',
    body: JSON.stringify(vaga)
  });
  const body = await res.json().catch(() => null);

  if (!res.ok) {
    const msg = body?.message || body?.error || res.statusText || 'Bad response createVaga';
    throw new Error(msg);
  }

  return await body;
}

export async function updateVaga(id, vaga) {
  const token = localStorage.getItem("token");
  const res = await fetch(`${API_BASE}/vagas/${id}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
    credentials: 'include',
    body: JSON.stringify(vaga)
  });
  const body = await res.json().catch(() => null);

  if (!res.ok) {
    const msg = body?.message || body?.error || res.statusText || 'Bad response updateVaga';
    throw new Error(msg);
  }

  return await body;
}

export async function deleteVaga(id) {
  const token = localStorage.getItem("token");

  const res = await fetch(`${API_BASE}/vagas/${id}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
    credentials: 'include',
  });
  const body = await res.json().catch(() => null);

  if (!res.ok) {
    const msg = body?.message || body?.error || res.statusText || 'Bad response deleteVaga';
    throw new Error(msg);
  }

  return await body;
}

// USERS -----------------------------------------------------------------------------------

export async function fetchUsers() {
  const token = localStorage.getItem("token");

  const res = await fetch(`${API_BASE}/users`, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${token}`
    },
    credentials: 'include',
  });

  const body = await res.json().catch(() => null);

  if (!res.ok) {
    const msg = body?.message || body?.error || res.statusText || 'Bad response fetchUsers';
    throw new Error(msg);
  }

  return await body;
}

export async function createUser(novo) {
  const token = localStorage.getItem("token");

  const res = await fetch(`${API_BASE}/users`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
    credentials: 'include',
    body: JSON.stringify(novo)
  });
  const body = await res.json().catch(() => null);

  if (!res.ok) {
    const msg = body?.message || body?.error || res.statusText || 'Bad response createUser';
    throw new Error(msg);
  }

  return await body;
}

export async function updateUser(id, novo) {
  const token = localStorage.getItem("token");

  const res = await fetch(`${API_BASE}/users/${id}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
    credentials: 'include',
    body: JSON.stringify(novo)
  });
  const body = await res.json().catch(() => null);

  if (!res.ok) {
    const msg = body?.message || body?.error || res.statusText || 'Bad response updateUser';
    throw new Error(msg);
  }

  return await body;
}

export async function deleteUser(id) {
  const token = localStorage.getItem("token");

  const res = await fetch(`${API_BASE}/users/${id}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
    credentials: 'include',
  });
  const body = await res.json().catch(() => null);

  if (!res.ok) {
    const msg = body?.message || body?.error || res.statusText || 'Bad response deleteUser';
    throw new Error(msg);
  }

  return await body;
}

// STATUS -----------------------------------------------------------------------------------

export async function fetchStatusAtivos() {
  const res = await fetch(`${API_BASE}/status/actives`, {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' }
  });
  const body = await res.json().catch(() => null);

  if (!res.ok) {
    const msg = body?.message || body?.error || res.statusText || 'Erro ao buscar status';
    throw new Error(msg);
  }

  return await body;
}
